(function() {
'use strict';
  
  angular
    .module('app.settings')
    .factory('settings', settings);
      
  settings.$inject = ['$log', 'localStorageService'];
    
  function settings($log, localStorageService) {
    var $log = $log.getInstance('settings');

    var actions = {
      get: get,
      load: load,
      reset: reset,
      save: save,
      set: set
    };
    var settings = {};

    _addActions();

    return settings;


    function get(path, defaultValue) {
      var r = _resolvePath(path);
      return r.obj[r.prop] || defaultValue;
    }

    function load() {
      var storedSettings = localStorageService.get('mars.settings') || {};
      angular.copy(storedSettings, settings);
      _addActions();
      $log.debug('Loaded settings:', settings);
    }

    function reset() {
      angular.copy(actions, settings);
    }

    function save() {
      localStorageService.set('mars.settings', settings);
      $log.debug('Saved settings:', settings);
    }

    function set(path, value) {
      var r = _resolvePath(path);
      r.obj[r.prop] = value;
    }

    function _addActions() {
      angular.extend(settings, actions);
    }
    
    function _resolvePath(path) {
      var obj = settings;
      if (angular.isString(path))
        path = path.split('.');
      if (!angular.isArray(path))
        throw new Error('Invalid path');
      for (var i = 0; i < path.length - 1; i++) {
        var p = path[i];
        if (!angular.isDefined(obj[p]))
          obj[p] = {};
        obj = obj[p];
      }
      return {
        obj: obj,
        prop: path[path.length - 1]
      };
    }

  }
  
})();